import { z } from 'zod';
import { $CandidateActivitySphere } from './CandidateActivitySphere';
import { $CandidateCurrency } from './CandidateCurrency';
import { $CandidateNamedReference } from './CandidateNamedReference';
import { $CandidatePaymentPeriod } from './CandidatePaymentPeriod';
import { $CandidateVacancy } from './CandidateVacancy';

const $CandidateResumeBase = z.object({
  resumeId: z.number(),
  candidateId: z.number(),
  salary: z.number().nullable(),
  desiredJob: z.string().nullable(),
  experience: z.string().nullable(),
  employmentDate: z.string().nullable(),
  is_active: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string().nullable(),
});

export const $CandidateResume = $CandidateResumeBase.extend({
  firstName: z
    .string()
    .nullable()
    .transform(firstName => firstName ?? ''),
  lastName: z
    .string()
    .nullable()
    .transform(lastName => lastName ?? ''),
  age: z.number().nullable(),
  phone: z.string(),
  preferredCommunicationLanguage: z.string().nullable(),
  currency: $CandidateCurrency.nullable(),
  paymentPeriod: $CandidatePaymentPeriod.nullable(),
  activitySpheres: z.array($CandidateActivitySphere),
  employmentTypes: z.array($CandidateNamedReference),
  scheduleWorks: z.array($CandidateNamedReference),
  skills: z.array($CandidateNamedReference),
  vacancies: z.array($CandidateVacancy),
});

export const $CandidateResumeRelation = $CandidateResumeBase.extend({
  id: z.number(),
});
